(() => {
  if (window.__oopsibopCartReady) return;
  window.__oopsibopCartReady = true;

  const routes = window.OopsibopRoutes || {};
  const root = routes.root || '/';
  const route = (value, fallback) => (value || `${root}${fallback}`).replace(/\/+$/, '');
  const jsonRoute = (value) => (value.endsWith('.js') ? value : `${value}.js`);
  const cartUrl = route(routes.cart, 'cart');
  const cartAdd = route(routes.cartAdd, 'cart/add');
  const cartChange = route(routes.cartChange, 'cart/change');

  const drawer = document.querySelector('[data-cart-drawer]');
  const scrim = document.querySelector('[data-cart-scrim]');
  const lines = document.querySelector('[data-cart-lines]');
  const total = document.querySelector('[data-cart-total]');
  const error = document.querySelector('[data-cart-error]');
  const countNodes = document.querySelectorAll('[data-cart-count]');
  let returnFocus = null;

  if (!drawer || !scrim || !lines || !total) return;

  const currency = window.Shopify?.currency?.active || 'USD';
  const money = (cents) => new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency,
  }).format((Number(cents) || 0) / 100);

  const setError = (message = '') => {
    if (!error) return;
    error.textContent = message;
    error.hidden = !message;
  };

  const setBusy = (busy, target = drawer) => {
    target.setAttribute('aria-busy', busy ? 'true' : 'false');
  };

  const updateCounts = (count) => {
    countNodes.forEach((node) => { node.textContent = String(count || 0); });
  };

  const createQuantityButton = (label, line, quantity) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'oo-cart-quantity-button';
    button.dataset.line = String(line);
    button.dataset.quantity = String(Math.max(0, quantity));
    button.setAttribute('aria-label', label);
    button.textContent = label.startsWith('Decrease') ? '−' : '+';
    return button;
  };

  const renderCart = (cart) => {
    lines.replaceChildren();
    if (!cart.items?.length) {
      const empty = document.createElement('p');
      empty.className = 'oo-cart-empty';
      empty.textContent = "Nothing in here. Much like Blue Mood's head.";
      lines.append(empty);
    } else {
      cart.items.forEach((item, index) => {
        const line = document.createElement('article');
        line.className = 'oo-cart-line';
        line.dataset.variantId = String(item.variant_id);

        if (item.image) {
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = item.product_title || item.title || '';
          image.width = 92;
          image.height = 92;
          line.append(image);
        }

        const details = document.createElement('div');
        details.className = 'oo-cart-line-details';
        const title = document.createElement('strong');
        title.textContent = item.product_title || item.title;
        details.append(title);

        if (item.variant_title && item.variant_title !== 'Default Title') {
          const variant = document.createElement('small');
          variant.textContent = item.variant_title;
          details.append(variant);
        }

        const controls = document.createElement('div');
        controls.className = 'oo-cart-quantity';
        controls.append(createQuantityButton(`Decrease ${title.textContent} quantity`, index + 1, item.quantity - 1));
        const quantity = document.createElement('span');
        quantity.textContent = String(item.quantity);
        quantity.setAttribute('aria-label', `Quantity ${item.quantity}`);
        controls.append(quantity);
        controls.append(createQuantityButton(`Increase ${title.textContent} quantity`, index + 1, item.quantity + 1));
        details.append(controls);

        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'oo-cart-remove';
        remove.dataset.line = String(index + 1);
        remove.dataset.quantity = '0';
        remove.textContent = 'Remove';
        details.append(remove);

        const price = document.createElement('strong');
        price.className = 'oo-cart-line-price';
        price.textContent = money(item.final_line_price);
        details.append(price);
        line.append(details);
        lines.append(line);
      });
    }

    updateCounts(cart.item_count);
    total.textContent = money(cart.total_price);
  };

  const request = async (url, options = {}) => {
    const response = await fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json', ...(options.headers || {}) },
      ...options,
    });
    const body = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(body.description || body.message || 'Something went sideways. Please try again.');
    return body;
  };

  const getCart = () => request(jsonRoute(cartUrl));

  const openCart = async (opener = document.activeElement) => {
    returnFocus = opener;
    setError();
    scrim.hidden = false;
    requestAnimationFrame(() => {
      document.body.classList.add('oo-cart-open');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.focus();
    });
    setBusy(true);
    try { renderCart(await getCart()); } catch (reason) { setError(reason.message); }
    finally { setBusy(false); }
  };

  const closeCart = () => {
    document.body.classList.remove('oo-cart-open');
    drawer.setAttribute('aria-hidden', 'true');
    window.setTimeout(() => { scrim.hidden = true; }, 260);
    returnFocus?.focus?.();
  };

  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-cart-open]');
    if (open) { event.preventDefault(); openCart(open); return; }
    if (event.target.closest('[data-cart-close]') || event.target === scrim) closeCart();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') closeCart();
  });

  lines.addEventListener('click', async (event) => {
    const control = event.target.closest('[data-line][data-quantity]');
    if (!control) return;
    setError();
    setBusy(true, lines);
    try {
      const cart = await request(jsonRoute(cartChange), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(control.dataset.line), quantity: Number(control.dataset.quantity) }),
      });
      renderCart(cart);
    } catch (reason) { setError(reason.message); }
    finally { setBusy(false, lines); }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    setError();
    const formData = new FormData(form);
    const variant_id = formData.get('id');
    if (!variant_id) return;
    setBusy(true, form);
    try {
      await request(jsonRoute(cartAdd), { method: 'POST', body: formData });
      renderCart(await getCart());
      await openCart(form.querySelector('[type="submit"]'));
    } catch (reason) {
      setError(reason.message);
      await openCart(form.querySelector('[type="submit"]'));
    } finally { setBusy(false, form); }
  });
})();
